import { render, staticRenderFns } from "./LocationManagementDialog.vue?vue&type=template&id=2622b85c&scoped=true"
import script from "./LocationManagementDialog.ts?vue&type=script&lang=js&external"
export * from "./LocationManagementDialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622b85c",
  null
  
)

export default component.exports